import { FunctionComponent } from "react";
import { TopbarSkeleton } from "@components/layout/topbar/topbar-skeleton";
import { useQuery } from "@apollo/client";
import { GQLMeQuery, GQLMeQueryVariables } from "queries/user.generated";
import { ME_QUERY } from "queries/user";
import { Logo } from "@components/layout/logo/logo";
import { Autocomplete } from "@components/search/autocomplete/autocomplete";
import Navbar from "@components/navbar/navbar";
import Player from "@components/player/player";

export interface TopbarProps {
    expanded: boolean;
    showLogo: boolean;
}

export const Topbar: FunctionComponent<TopbarProps> = ({ showLogo, expanded }) => {
    const { data: dataMe, loading: loadingMe } = useQuery<GQLMeQuery, GQLMeQueryVariables>(ME_QUERY);

    if (loadingMe) return <TopbarSkeleton expanded={expanded} />;

    return (
        <>
            {dataMe?.me && <Player />}
            {showLogo && (
                <div className="-ml-2 mr-8 hidden lg:block">
                    <Logo expanded={expanded} />
                </div>
            )}
            <div>
                <div className="-ml-3 lg:hidden">
                    <Logo expanded={expanded} />
                </div>
                <div className="hidden w-[450px] lg:block">
                    <Autocomplete />
                </div>
            </div>
            <div className="ml-auto flex items-center gap-1">
                <Navbar />
            </div>
        </>
    );
};
